import React from 'react';
import { TopBar } from './components/TopBar';
import { PurchaseToast } from './components/PurchaseToast';
import { Hero } from './components/sections/Hero';
import { Situation } from './components/sections/Situation';
import { ProfilePaths } from './components/sections/ProfilePaths';
import { Applications } from './components/sections/Applications';
import { Solution } from './components/sections/Solution';
import { Modules } from './components/sections/Modules';
import { InteriorPages } from './components/sections/InteriorPages';
import { Benefits } from './components/sections/Benefits';
import { Bonuses } from './components/sections/Bonuses';
import { Steps } from './components/sections/Steps';
import { Audience } from './components/sections/Audience';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { Offer } from './components/sections/Offer';
import { Testimonials } from './components/sections/Testimonials';
import { SecurePurchase } from './components/sections/SecurePurchase';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
export function App() {
  return <div className="min-h-screen w-full bg-white" data-id="element-0" data-mp="3mjgclt42snpw">
      <TopBar data-id="element-1" data-mp="3rdapodp6e4g0" />
      <main data-id="element-2" data-mp="3rdkkqfp2v1sk">
        <Hero data-id="element-3" data-mp="3rd19tixuhdo1" />
        <Situation data-id="element-4" data-mp="3reltgdimfc74" />
        <ProfilePaths data-id="element-5" data-mp="5ott78p769p" />
        <Testimonials data-id="element-6" data-mp="682dxcgkib2" />
        <Solution data-id="element-7" data-mp="5gfdawxfswe" />
        <Modules data-id="element-8" data-mp="82k72sfnuax" />
        <InteriorPages data-id="element-9" data-mp="2zl3bdjx5744s" />
        <Benefits data-id="element-10" data-mp="2zlv6ktmtuzuj" />
        <Bonuses data-id="element-11" data-mp="2zmepackaxs9m" />
        <Steps data-id="element-12" data-mp="2zmwi0z7r9ocs" />
        <Audience data-id="element-13" data-mp="2zn678kkz7rhf" />
        <Applications data-id="element-14" data-mp="33mf2xuzktzfm" />
        <BeforeAfter data-id="element-15" data-mp="33lwzoeehyky7" />
        <Offer data-id="element-16" data-mp="33ngiabnml835" />
        <SecurePurchase data-id="element-17" data-mp="33mylndx1wrup" />
        <Faq data-id="element-18" data-mp="38lrq6gud18iq" />
        <FinalCta data-id="element-19" data-mp="38l8hzruihyhw" />
      </main>
      <footer className="bg-brand-950 py-8 text-center text-sm text-brand-200" data-id="element-20" data-mp="38l04pyuh8r66">
        <p data-id="element-21" data-mp="3dl4llpzarnwx">© {new Date().getFullYear()} REACTIVA TU CUERPO™ · Todos los derechos reservados.</p>
        <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs" data-id="element-22" data-mp="nwc39wy9i3yd">
          <span className="font-semibold text-white" data-id="element-23" data-mp="stue5svuat90">@armate digital</span>
          <a href="mailto:armatedigitalsoporte@gmail.com" className="underline decoration-brand-200/40 underline-offset-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-24" data-mp="36hw15qrsq0p">
            armatedigitalsoporte@gmail.com
          </a>
        </p>
      </footer>
      <PurchaseToast data-id="element-25" data-mp="d3wd97kipiu2" />
    </div>;
}